/* unplugin-vue-components disabled */import { render } from "./KilaKilaCard.vue?vue&type=template&id=0fd8da43&scoped=true"
import script from "./KilaKilaCard.vue?vue&type=script&lang=js"
export * from "./KilaKilaCard.vue?vue&type=script&lang=js"

import "./KilaKilaCard.vue?vue&type=style&index=0&id=0fd8da43&scoped=true&lang=css"

import exportComponent from "E:\\Jweb\\结课作业\\KilaKila-Blog\\kilakila-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd8da43"]])

export default __exports__